import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
// import AlfredImg from "../../assets/images/alfred.png";
import AlfredGif from "../../assets/images/alfred-2.gif";
import ButtonTestFree from "../../Components/ButtonTestFree";
import {
  AuthorCompany,
  AuthorName,
  Avatar,
  CommentCard,
  CommentFooter,
  CommentText,
} from "../../Components/Comments/card";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #FFFFFF;
`;


const Feedbacks = () => {
  return (
    <Container
      style={{
        textAlign: "center",
        paddingTop: "80px",
        paddingBottom: "80px",
      }}
      id="section-11"
    >
      <Title>Quem já usa o <span style={{color: '#E4DA1B'}}>Alfred</span>, sente a diferença</Title>
      <br />
      <br />
      <Row
        lg="1fr 1fr 1fr"
        sm="1fr"
        style={{ alignItems: "center", width: "100%", margin: 'auto' }}
      >
        <CommentCard>
          {/* <Avatar>
            <img src="/batman.png" alt="Avatar" />
          </Avatar> */}

          <CommentText>
            “Eu perdia muita mensagem fora do horário. Com o Alfred, meus clientes são atendidos na hora, mesmo quando estou ocupado. Só isso já mudou meu jogo.”
          </CommentText>

          <CommentFooter>
            <AuthorName>Carlos Henrique</AuthorName>
            <AuthorCompany>Prime Serviços Residenciais</AuthorCompany>
          </CommentFooter>
        </CommentCard>
        <CommentCard>
          {/* <Avatar>
            <img src="/batman.png" alt="Avatar" />
          </Avatar> */}

          <CommentText>
           “Eu perdia muito lead por demora na resposta, principalmente em lançamentos. Hoje o WhatsApp funciona no automático, qualificando e respondendo as perguntas enquanto eu foco no conteúdo.”
          </CommentText>

          <CommentFooter>
            <AuthorName>Lucas Andrade</AuthorName>
            <AuthorCompany>Infoprodutor de Marketing Digital</AuthorCompany>
          </CommentFooter>
        </CommentCard>
        <CommentCard>
          {/* <Avatar>
            <img src="/batman.png" alt="Avatar" />
          </Avatar> */}

          <CommentText>
           “Nos horários de pico, o WhatsApp não parava. O Alfred passou a responder automaticamente e hoje meus clientes não ficam mais esperando.”
          </CommentText>

          <CommentFooter>
            <AuthorName>Fernanda Lucena</AuthorName>
            <AuthorCompany>Restaurante Sabor de Minas</AuthorCompany>
          </CommentFooter>
        </CommentCard>
      </Row>
    </Container>
  );
};

export default Feedbacks;
